module.exports = __webpack_public_path__ + "img/img69.f6132313.svg";